<template>
    <div id="contenedor-seccion-accionesHeader-intranet" class="container-fluid">
        <div class="d-flex justify-content-between">
            <!-- MENU -->
            <div class="d-flex justify-content-start">
                <div class="dropdown">
                    <button id="ac-desplegar-menu-btn" type="button" @click="desplegarMenu" class="btn btn-primary">
                        <i id="ac-desplegar-menu-icono" :class="(!menuEstaDesplegado) ? 'fas fa-bars' : 'fas fa-times'"></i>
                    </button>
                    <transition name="fade" mode="out-in">
                         <div id="myDropdown" class="dropdown-content" v-show="menuEstaDesplegado">
                            <div class="row">
                                 <div id="barra-busqueda-resolucion-movil" class="d-flex justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4">
                                    <div class="input-group col-8">
                                        <input class="form-control input-sm input-xs input-md input-lg py-2 border-right-0 border" type="search" placeholder="Buscar">
                                        <div class="input-group-append">
                                            <div class="input-group-text"><i class="fa fa-search"></i></div>
                                        </div>
                                    </div>
                                </div>
                                <!-- MENUS (De momento el diseno no necesita de formato recursivo en caso de requerirlo remplazar por componentes recursivos) -->
                                <div id="contenedor-menu" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pt-4" v-for="(menu,index) in menus" :key="'menu' + index">
                                    <a v-if="campoRequeridoEsValido(menu.RutaParaAccesar)&& menu.RutaParaAccesar.includes('http')" @click="ocultarMenu" class="menu" target="_blank" :href="menu.RutaParaAccesar">{{ menu.Titulo }}</a>
                                    <router-link v-else-if="campoRequeridoEsValido(menu.RutaParaAccesar)" @click.native="ocultarMenu" class="menu" :to="menu.RutaParaAccesar">{{ menu.Titulo }}</router-link>
                                    <!-- SUBMENUS -->
                                    <div class="contendor-submenu" v-for="(submenu,index) in menu.Submenus" :key="'submenu' + index">
                                        <a v-if="campoRequeridoEsValido(submenu.RutaParaAccesar) && submenu.RutaParaAccesar.includes('http')" @click="ocultarMenu" class="submenu" target="_blank" :href="submenu.RutaParaAccesar">{{ submenu.Titulo }}</a>
                                        <router-link v-else-if="campoRequeridoEsValido(submenu.RutaParaAccesar)" @click.native="ocultarMenu" class="submenu" :to="submenu.RutaParaAccesar">{{ submenu.Titulo }}</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            <!-- BARRA DE BUSQUEDA -->
            <div id="barra-busqueda" class="d-flex justify-content-center col-8">
                 <div class="input-group col-8">
                    <input id="ac-desplegar-menu-busqueda" class="form-control input-sm input-xs input-md input-lg py-2 border-right-0 border" type="search" placeholder="Buscar">
                    <div class="input-group-append">
                        <div id="ac-desplegar-menu-busqueda-div" class="input-group-text"><i id="ac-desplegar-menu-busqueda-icono" class="fa fa-search"></i></div>
                    </div>
                </div>
            </div>
            <!-- ACCIONES EXTRA -->
            <div id="acciones-extra" class="form-inline justify-content-between">
                 <i class="fas fa-question-circle mr-3"></i>
                 <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            menuEstaDesplegado: false,
            menus: [
                { 
                    Titulo: 'Clínicas Procesales', 
                    RutaParaAccesar: '/Intranet/Documentos/ClínicasProcesales',
                    Submenus: [ 
                                { Titulo: 'Clínicas Procesales Civil', RutaParaAccesar: '/Intranet/Clinicas/2021' },
                                { Titulo: 'Clínicas Procesales Mercantiles', RutaParaAccesar: '/Intranet/Clinicas/2017' },
                                { Titulo: 'Clínicas Procesales Familiares', RutaParaAccesar: '/Intranet/Clinicas/2017' },
                                { Titulo: 'Clínicas Procesales Penal', RutaParaAccesar: '/Intranet/Clinicas/Penal' }/* ,
                                { Titulo: 'Clínica Procesal Familiar', RutaParaAccesar: '/Intranet/Clinicas/2011' },
                                { Titulo: 'Clínica Procesal Penal', RutaParaAccesar: '/Intranet/Clinicas/2011' } */
                     ] 
                },
                { 
                    Titulo: 'Firma Electrónica', 
                    RutaParaAccesar: '/Intranet/Documentos/FirmaElectrónica',
                    Submenus: [ 
                        { Titulo: 'Aplicación para Firmar Documentos Electrónicamente', RutaParaAccesar: '/FirmaElectronica/FirmarDocumentos' },
                     ] 
                },
                { 
                    Titulo: 'Edictos', 
                    RutaParaAccesar: '/Intranet/Documentos/Edictos',
                    Submenus: [
                        { Titulo: 'Aplicación para el envío de Edictos', RutaParaAccesar: '/Intranet/Edictos/Envio' }
                     ] 
                },
                { 
                    Titulo: 'Sentencias', 
                    RutaParaAccesar: '/Intranet/Documentos/Sentencias',
                    Submenus: [ 
                        { Titulo: 'Aplicación para la publicación de Sentencias', RutaParaAccesar: '/Intranet/Inicio' }
                     ] 
                },
                { 
                    Titulo: 'Resultados Clima Laboral', 
                    RutaParaAccesar: '/Intranet/Documentos/ResultadosClimaLaboral',
                    Submenus: [ 
                        { Titulo: 'Resultados de la Encuesta de Clima Laboral aplicada a Personal Judicial del Supremo Tribunal de Justicia del Estad de Aguascalientes', RutaParaAccesar: '/Intranet/Inicio' },
                        { Titulo: 'Concentrado de Respuestas de la Encuesta de Clima Laboral aplicada a Personal Judicial del Supremo Tribunal de Justicia del Estad de Aguascalientes', RutaParaAccesar: '/Intranet/Inicio' }
                     ] 
                },
                { 
                    Titulo: 'Presidencia', 
                    RutaParaAccesar: '/Intranet/Documentos/Presidencia',
                    Submenus: [ 
                        { Titulo: 'Comunicados Presidencia', RutaParaAccesar: '/Intranet/Presidencia/Comunicados' }
                     ] 
                },
                { 
                    Titulo: 'Consejo de la Judicatura Estatal', 
                    RutaParaAccesar: '/Intranet/Documentos/ConsejoDeLaJudicaturaEstatal',
                    Submenus: [ 
                        { Titulo: 'Convocatorias', RutaParaAccesar: '/Intranet/Convocatorias/1' },
                        { Titulo: 'Acuerdo de aceptados a la segunda etapa', RutaParaAccesar: '/Intranet/Inicio' }
                     ] 
                },
                { 
                    Titulo: 'Sala Civil', 
                    RutaParaAccesar: '/Intranet/Documentos/SalaCivil',
                    Submenus: [ 
                        { Titulo: 'Archivos de consulta', RutaParaAccesar: '/Intranet/Inicio' }
                     ] 
                },
                { Titulo: 'Oficialia Mayor', 
                    RutaParaAccesar: '/Intranet/Documentos/OficialiaMayor',
                    Submenus: [
                        ] 
                },
                { Titulo: 'Contraloría', 
                    RutaParaAccesar: '/Intranet/Documentos/Contraloría',
                    Submenus: [
                            { Titulo: 'DECLARACIÓN DE CONFLICTO DE INTERESES.', RutaParaAccesar: '/Intranet/Inicio' },
                            { Titulo: 'DECLARACIÓN DE CONFLICTO DE INTERESES.pdf', RutaParaAccesar: '/Intranet/Inicio' }
                        ] 
                },
                { Titulo: 'Instituto de Capacitación', 
                    RutaParaAccesar: '/Intranet',
                    Submenus: [
                        ] 
                },
                { Titulo: 'Informática', 
                    RutaParaAccesar: '/Intranet/Documentos/Informática',
                    Submenus: [
                            { Titulo: 'Calendario Mensual', RutaParaAccesar: '/Intranet/Inicio' },
                            { Titulo: 'Calendario Mensual General 2021', RutaParaAccesar: '/Intranet/Inicio' },
                            { Titulo: 'Directorio Telefonico Civil', RutaParaAccesar: '/Intranet/Inicio' },
                            { Titulo: 'Directorio Telefonico Penal', RutaParaAccesar: '/Intranet/Inicio' },
                            { Titulo: 'Mapa Juzgado Mixto y Oral de Jesus Maria', RutaParaAccesar: '/Intranet/Inicio' }
                        ] 
                },
                { Titulo: 'Sistema Penal Acusatorio', 
                    RutaParaAccesar: '/Intranet/Documentos/SistemaPenalAcusatorio',
                    Submenus: [
                            { Titulo: 'Comunicados Presidencia', RutaParaAccesar: '/Intranet/Inicio' }
                        ] 
                },
            ]
        }
    },
    methods: {
        desplegarMenu: function() {
            /* if(this.menuEstaDesplegado)
                $("#myDropdown").removeClass('show');
            else
                $("#myDropdown").addClass('show'); */
            this.menuEstaDesplegado = !this.menuEstaDesplegado;
        },
        ocultarMenu: function() { 
            this.menuEstaDesplegado = false;
          /*   this.$nextTick(() => {
                $(window).scrollTop(0);
            }); */
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    mounted() {
        $("#contendro-principal-intranet-plantilla").on('click',(event) => {
            let elementoSeleccionado = event.target.getAttribute('id');
            const ID_BTN_MENU = 'ac-desplegar-menu';
            const MENU_DOM = $("#myDropdown");
            /* console.log('entro::',elementoSeleccionado); */
            if(!this.campoRequeridoEsValido(elementoSeleccionado) || !elementoSeleccionado.startsWith(ID_BTN_MENU)) {
                if(MENU_DOM !== event.target && !MENU_DOM.has(event.target).length){
                    if(this.menuEstaDesplegado) {}
                        this.ocultarMenu();
                } 
            } 
        });
    },  
    computed: {

    }
}
</script>
<style scoped>
#contenedor-seccion-accionesHeader-intranet {
    background-color: #474545;
    min-height: 7vh;
    color: #FFFFFF;
    padding: 10px 20px 10px 20px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: block;
  top: 5.3vh;
  position: absolute;
  background-color: #f1f1f1;
  min-width: calc(100vw - 50px);
  box-shadow: 0px 8px 16px 0px rgba(31, 31, 31, 0.2);
  z-index: 666666;
  padding: 0px 30px 20px 30px;
}

/* .show { 
    display:block; 
} */

.dropdown .btn-primary {
    background-color: black;
    color: #FFFFFF;
    padding: 2px 10px 2px 10px;
    box-shadow: none;
}

.dropdown .btn:active,
.dropdown .btn:focus,
.dropdown .btn.active,
.dropdown .btn:active:focus {
   background-image: none;
   outline: 0;
   -webkit-box-shadow: none;
   box-shadow: none;
   background-color: black;
}

.menu {
    color: black;
    font-size: 2.7vmin;
    font-weight: bold;
}

.submenu {
    color: black;
    font-size: 1.5vmin;
}

.submenu:hover {
    font-weight: bold;
}

#contenedor-menu div {
    margin-bottom: 1px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.50s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#barra-busqueda .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
}

#barra-busqueda .input-group-text {
    background-color: white;
    color: rgb(63, 62, 62);
}

#barra-busqueda i {
    cursor: pointer;
}

#acciones-extra i {
    cursor: pointer;
    font-size: 1.5em;
}

#barra-busqueda-resolucion-movil {
    display: none !important;
}

@media screen and (max-width: 600px) {
    #barra-busqueda {
        display: none !important;
    }

    #barra-busqueda-resolucion-movil {
        display: block !important;
        position: initial;
        padding-left: 0;
    }

    #barra-busqueda-resolucion-movil .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
    }

    #barra-busqueda-resolucion-movil .input-group-text {
        background-color: white;
        color: rgb(63, 62, 62);
    }
}

</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/Estructura/Header/CSeccionAcciones.vue